(function () {
	const _menu = document.getElementById('mobile-menu');
	
	if (!_menu) {
		return;
	}
	
	function init() {
		_menu.addEventListener('click', click);
	}
	
	function click(event) {
		const _target = event.target;
		
		if (!util.hasClass(_target, 'js-mobile-menu-link') || _target.getAttribute('href') === '/hu/tanosvenyek' || !_target.nextElementSibling) {
			return;
		}
		
		event.preventDefault();
		
		const _visibleSubmenus = _menu.querySelectorAll('.js-mobile-menu-submenu.is-open');
		
		for (let i = 0, length = _visibleSubmenus.length; i < length; i++) {
			if (!util.hasParent(_target, _visibleSubmenus[i]) && _visibleSubmenus[i].previousElementSibling !== _target) {
				util.removeClass(_visibleSubmenus[i].previousElementSibling, 'is-active');
				util.removeClass(_visibleSubmenus[i], 'is-open');
			}
		}
		
		util.toggleClass(_target, 'is-active');
		util.toggleClass(_target.nextElementSibling, 'is-open');
	}
	
	init();
}());